
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { Users, Car, Calendar, CheckCircle, XCircle, Clock, Star, CreditCard } from "lucide-react";

interface DashboardStatsProps {
  stats: {
    totalUsers: number;
    totalParkingSpots: number;
    totalBookings: number;
    activeBookings: number;
    completedBookings: number;
    cancelledBookings: number;
    pendingApprovals: number;
    averageRating: number;
    revenue: number;
  };
}

export const DashboardStats = ({ stats }: DashboardStatsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <Card>
        <CardHeader className="pb-2 flex flex-row items-center justify-between">
          <div>
            <CardTitle className="text-2xl">{stats.totalUsers}</CardTitle>
            <CardDescription>Total Users</CardDescription>
          </div>
          <Users className="h-5 w-5 text-blue-500" />
        </CardHeader>
      </Card>
      
      <Card>
        <CardHeader className="pb-2 flex flex-row items-center justify-between">
          <div>
            <CardTitle className="text-2xl">{stats.totalParkingSpots}</CardTitle>
            <CardDescription>Parking Spots</CardDescription>
          </div>
          <Car className="h-5 w-5 text-green-500" />
        </CardHeader>
      </Card>
      
      <Card>
        <CardHeader className="pb-2 flex flex-row items-center justify-between">
          <div>
            <CardTitle className="text-2xl">{stats.totalBookings}</CardTitle>
            <CardDescription>Total Bookings</CardDescription>
          </div>
          <Calendar className="h-5 w-5 text-purple-500" />
        </CardHeader>
      </Card>
      
      <Card>
        <CardHeader className="pb-2 flex flex-row items-center justify-between">
          <div>
            <CardTitle className="text-2xl">{stats.activeBookings}</CardTitle>
            <CardDescription>Active Bookings</CardDescription>
          </div>
          <Clock className="h-5 w-5 text-yellow-500" />
        </CardHeader>
      </Card>

      <Card>
        <CardHeader className="pb-2 flex flex-row items-center justify-between">
          <div>
            <CardTitle className="text-2xl">{stats.completedBookings}</CardTitle>
            <CardDescription>Completed Bookings</CardDescription>
          </div>
          <CheckCircle className="h-5 w-5 text-emerald-500" />
        </CardHeader>
      </Card>
      
      <Card>
        <CardHeader className="pb-2 flex flex-row items-center justify-between">
          <div>
            <CardTitle className="text-2xl">{stats.cancelledBookings}</CardTitle>
            <CardDescription>Cancelled Bookings</CardDescription>
          </div>
          <XCircle className="h-5 w-5 text-red-500" />
        </CardHeader>
      </Card>
      
      <Card>
        <CardHeader className="pb-2 flex flex-row items-center justify-between">
          <div>
            <CardTitle className="text-2xl">{stats.pendingApprovals}</CardTitle>
            <CardDescription>Pending Approvals</CardDescription>
          </div>
          <Clock className="h-5 w-5 text-amber-500" />
        </CardHeader>
      </Card>
      
      <Card>
        <CardHeader className="pb-2 flex flex-row items-center justify-between">
          <div>
            <CardTitle className="text-2xl">{stats.averageRating.toFixed(1)}</CardTitle>
            <CardDescription>Average Rating</CardDescription>
          </div>
          <Star className="h-5 w-5 text-yellow-500 fill-yellow-500" />
        </CardHeader>
      </Card>
      
      <Card>
        <CardHeader className="pb-2 flex flex-row items-center justify-between">
          <div>
            <CardTitle className="text-2xl">₹{stats.revenue.toFixed(2)}</CardTitle>
            <CardDescription>Total Revenue</CardDescription>
          </div>
          <CreditCard className="h-5 w-5 text-indigo-500" />
        </CardHeader>
      </Card>
    </div>
  );
};
